import {useState} from 'react'

import {useAppSelector} from '../../hooks/redux'

import {HttpStatusError} from '../../../../commons/src/libs/http-json'
import download from '../../../../commons/src/services/download'
import * as internalApi from '../../services/api/internal'
import * as partnerApi from '../../services/api/partner'

import downloadIcon from '../../../../commons/src/assets/icons/download-box.svg'

import ActionBar from '../../../../commons/src/components/action-bar'
import Headline from '../../../../commons/src/components/headline'
import Icon from '../../../../commons/src/components/icon'
import LinkButton from '../../../../commons/src/components/link-button'
import MessageAttachment from '../../../../commons/src/components/order-message-list/MessageAttachment'
import Paragraph from '../../../../commons/src/components/paragraph'
import Stack from '../../../../commons/src/components/stack'

import {BackendModelAttachment, ModelId, OrderId} from '../../order-types'

type Props = {
  note: string
  attachments: BackendModelAttachment[]
  orderId: OrderId
  modelId: ModelId
}

const downloadErrorLabel = {
  attachmentNotFound:
    'The attachment you are trying to access is not available. It may have been removed from the model.',
  downloadError:
    'Unfortunately, we were not able to download the requested file. Please try again later.',
}

const ProductionDetailsModalContent = ({note, attachments, orderId, modelId}: Props) => {
  const [downloadError, setDownloadError] = useState<'attachmentNotFound' | 'downloadError'>()

  const isAdminMode = useAppSelector(state => state.auth.isAdminMode)
  const api = isAdminMode ? internalApi : partnerApi

  return (
    <Stack space="300">
      <Stack>
        <Headline label="Note" />
        <Paragraph>{note || '-'}</Paragraph>
      </Stack>
      <Stack>
        <Headline label="Attachments" />
        {(attachments ?? []).length > 0 ? (
          <ActionBar space="100" spaceRow="70">
            {attachments.map(attachment => (
              <MessageAttachment
                key={attachment.id}
                headline={attachment.name}
                button={
                  <LinkButton
                    icon={<Icon source={downloadIcon} />}
                    onClick={() =>
                      api
                        .getModelAttachmentDownload(orderId, modelId, attachment.id)
                        .then(response => download(response.url))
                        .catch(error => {
                          if (error instanceof HttpStatusError && error.response.status === 404) {
                            setDownloadError('attachmentNotFound')
                          } else {
                            setDownloadError('downloadError')
                          }
                        })
                    }
                  />
                }
              />
            ))}
          </ActionBar>
        ) : (
          '-'
        )}
        {downloadError && (
          <Paragraph size="s" error>
            {downloadErrorLabel[downloadError]}
          </Paragraph>
        )}
      </Stack>
    </Stack>
  )
}

export default ProductionDetailsModalContent
